import Swal from "sweetalert2";
import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { toast } from "react-hot-toast";
const translateToReactSelect = (
  reverse,
  arrayValue,
  labelName,
  needArray = false,
  valueName = "id"
) => {
  let after = [];
  if (reverse) {
    // react select to api
    for (let index = 0; index < arrayValue.length; index++) {
      let obj = {};
      if (arrayValue[index][valueName]) {
        obj[valueName] = arrayValue[index][valueName];
      } else {
        obj[labelName] = arrayValue[index].label;
        obj[valueName] = arrayValue[index].value;
      }

      after.push(obj[valueName]);
    }
  } else {
    // api to react select
    for (let index = 0; index < arrayValue?.length; index++) {
      let obj = {};
      if (needArray) {
        const {
          id,
          [labelName]: removedProperty,
          ...remain
        } = arrayValue[index];
        obj = { ...obj, ...remain };
      }
      obj.label = arrayValue[index][labelName];
      obj.value = arrayValue[index][valueName];

      after.push(obj);
    }
  }
  return after;
};

const swalFunc = (
  title,
  confirmFunc,
  icon = "default",
  confirmBtnColor = "#1d8448",
  cancelBtnColor = "#d33",
  confirmBtnTxt = "بله",
  cancelBtnTxt = "خیر"
) => {
  Swal.fire({
    title: title,
    icon: icon,
    showCancelButton: true,
    confirmButtonColor: confirmBtnColor,
    cancelButtonColor: cancelBtnColor,
    confirmButtonText: confirmBtnTxt,
    cancelButtonText: cancelBtnTxt,
  }).then((result) => {
    if (result.isConfirmed) {
      confirmFunc();
    }
  });
};
const TimeStampToJalali = (timestamp, format) => {
  let date = new DateObject({
    date: timestamp,
  }).convert(persian, persian_fa);
  return date.format(format);
};

const searchFunc = (txtSearch, text) => {
  let y = [];
  let yId = [];
  let x = text.filter((value) => {
    Object.keys(value).forEach((element) => {
      if (
        value[element] != null &&
        typeof value[element] != "object" &&
        typeof value[element] != "array" &&
        typeof value[element] != "boolean" &&
        typeof value[element] != "number" &&
        value[element] != ""
      ) {
        if (
          (isNaN(value[element]) && value[element].includes(txtSearch)) ||
          (!isNaN(value[element]) &&
            !isNaN(txtSearch) &&
            value[element].includes(txtSearch))
        ) {
          if (y.length == 0) {
            y.push(value);
            yId.push(value.id);
          } else {
            if (!yId.includes(value.id)) {
              y.push(value);
              yId.push(value.id);
            }
          }
        }
      }
    });
  });

  return y;
};

const pathMaker = (path) => {
  if (path !== undefined) return `http://irancovercrmb.tatdemo.ir/${path}`;
  else return path;
};
function groupBy(objectArray, property) {
  return objectArray.reduce((acc, obj) => {
    const key = obj[property];
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, {});
}
/**
 *
 * @param {*} string/formul
 * @param {*} value /compare value
 * @param {*} productProperty /list of propertys
 * @param {*} type / if it's a compare wit just reduce the first character
 * @returns
 */
const convertFormul = (
  string = "<= 99 - 10 * 4 + 3 * 2 + 10",
  value = 42,
  productProperty,
  type = "compare" //value
) => {
  let list = string.split(" ");

  let mainOperator = list[0] ?? 0;
  let operatorMainFa = "";
  let compareValue = 0;
  list = type == "compare" ? list.splice(1) : list;

  let newList = list.map((v) => {
    if (v.includes("prpr_id_")) {
      let pro = {};

      let t = v.split("_");
      let prId = t[t.length - 1];
      pro = productProperty.filter((v) => v.id == prId)[0];

      toast.error(`اپشن ${pro?.title} به محصول متصل نیست`);
      return 0;
    } else return v;
  });
  let result = "";
  let multipleIndex = newList.indexOf("*");
  let divideIndex = newList.indexOf("/");
  let plusIndex = newList.indexOf("+");
  let minuesIndex = newList.indexOf("-");
  switch (mainOperator) {
    case "=":
      result = parseInt(newList[0]) == parseInt(value);
      operatorMainFa = "مساوی";
      break;
    case ">=":
      result = parseInt(value) >= parseInt(newList);
      operatorMainFa = " بزرگتر مساوی";
      break;
    case ">":
      result = parseInt(value) > parseInt(newList);
      operatorMainFa = " بزرگتر ";

      break;
    case "<=":
      result = parseInt(value) <= parseInt(newList);
      operatorMainFa = " کوچکتر مساوی";

      break;
    case "<":
      result = parseInt(value) < parseInt(newList);
      operatorMainFa = " کوچکتر";

      break;
    default:
      result = "";
      break;
  }

  if (
    multipleIndex != -1 ||
    divideIndex != -1 ||
    plusIndex != -1 ||
    minuesIndex != -1
  ) {
    compareValue = eval(newList.toString().replaceAll(",", ""));
  } else compareValue = newList;
  return {
    operator: operatorMainFa,
    compareValue: compareValue ?? 0,
    result: result,
  };
};
const convertFormulToShow = (formul, attributeList) => {
  if (formul.includes("prpr_id_")) {
    let arrayFormul = formul.split(" ");

    let result = arrayFormul
      .map((v) => {
        if (v.includes("prpr_id")) {
          let propertyId;
          let x = v.split("_");
          propertyId = x[x.length - 1];
          let propertyName =
            attributeList.filter((v) => v.property_id == propertyId)[0]
              ?.title ?? "";
          console.log("object eval eval newList", propertyName);

          return propertyName;
        } else return v;
      })
      .join()
      .replaceAll(",", " ");
    return result;
  } else return formul;
};

const irancoverData = {
  title: "شرکت صدرا بی‌بافت صنعت هیرکان",
  economical_number: "",
  identification_code: "14009641280",
  province: "گلستان",
  township: "گرگان",
  city: "گرگان",
  postalCode: "4931169557",
  custom_address: "شهرک صنعتی آق‌قلا - فاز 3- تولید 4",
  tell: "01734534066-69",
};
const additionalPrice = [
  {
    title: "هزینه دسته بندی",
    price: "450",
    needNumber: false,
    checked: false,
    numberTitle: "",
    priceOnEach: true,
    count: 1,
    more_option_value: "1",
    id: 1,
    priority: 6,
  },
  {
    title: "هزینه چاپ سیلک معمولی",
    price: "550",
    needNumber: true,
    numberTitle: "تعداد ضرب چاپ",
    priceOnEach: true,
    checked: false,
    count: 1,
    more_option_value: "1",
    id: 2,
    priority: 1,
  },
  {
    title: `هزینه چاپ سیلک `,
    description: "(طلایی، نقره ای، سفید)",
    price: "750",
    needNumber: true,
    numberTitle: "تعداد ضرب چاپ",
    priceOnEach: true,
    checked: false,
    count: 1,
    more_option_value: "1",
    id: 3,
    priority: 2,
  },
  // {
  //   title: "هزینه چاپ سیلک نقره ای",
  //   price: "750",
  //   needNumber: true,
  //   checked: false,
  //   count: 1, more_option_value:''1,
  //   id: 4,
  // priority:  // },
  // {
  //   title: "هزینه چاپ سیلک سفید",
  //   price: "750",
  //   needNumber: true,
  //   checked: false,
  //   count: 1, more_option_value:''1,
  //   id: 5,
  // priority:  // },
  {
    title: "هزینه کلیشه سیلک",
    price: "100000",
    needNumber: true,
    numberTitle: "تعداد",
    priceOnEach: false,
    checked: false,
    count: 1,
    more_option_value: "1",
    id: 6,
    priority: 5,
  },
  {
    title: "هزینه HIBag",
    price: "600",
    needNumber: false,
    numberTitle: "",
    priceOnEach: true,
    checked: false,
    count: 1,
    more_option_value: "1",
    id: 7,
    priority: 7,
  },
  {
    title: "طرحدار",
    price: "1000",
    needNumber: false,
    numberTitle: "",
    priceOnEach: true,
    checked: false,
    count: 1,
    more_option_value: "1",
    id: 8,
    priority: 8,
  },
  {
    title: "دکمه",
    price: "600",
    needNumber: true,
    numberTitle: "تعداد",
    checked: false,
    priceOnEach: true,
    count: 1,
    more_option_value: "1",
    id: 9,
    priority: 9,
  },

  {
    title: "چاپ فلکسو",
    more_option: [
      { title: "یکطرفه", value: 1 },
      { title: "دوطرفه", value: 2 },
    ],
    price: "350",
    needNumber: false,
    numberTitle: "تعداد ضرب چاپ",
    priceOnEach: true,
    checked: false,
    count: 1,
    more_option_value: "1",
    id: 10,
    priority: 3,
  },
  {
    title: "چاپ افست",
    more_option: [
      { title: "یکطرفه", value: 1 },
      { title: "دوطرفه", value: 2 },
    ],
    price: "3500",
    needNumber: false,
    numberTitle: "تعداد ضرب چاپ",
    priceOnEach: true,
    checked: false,
    more_option_value: "1",
    count: 1,
    id: 11,
    priority: 4,
  },
  {
    title: "طراحی",
    price: "350000",
    needNumber: false,
    numberTitle: "",
    checked: false,
    count: 1,
    more_option_value: "1",
    id: 12,
    priority: 10,
    priceOnEach: false,
  },
];
export {
  translateToReactSelect,
  swalFunc,
  TimeStampToJalali,
  searchFunc,
  pathMaker,
  groupBy,
  convertFormul,
  convertFormulToShow,
  irancoverData,
  additionalPrice,
};
